module.exports = __webpack_public_path__ + "img/icon-teacher-logo.6ef16352.png";